import { getJobTeaserFragment } from '~/jobiqo/components/Job/graphql/fragments/jobTeaserFragment';
import { gql } from '@apollo/client';

export const getMatchingJobs = () => gql`
  ${getJobTeaserFragment(undefined)}
  query getMatchingJobs(
    $context: MatchingContext!
    $entityId: Int!
    $itemsPerPage: Int
    $page: Int
  ) {
    getMatchingJobs(
      context: $context
      entityId: $entityId
      itemsPerPage: $itemsPerPage
      page: $page
    ) {
      totalCount
      items {
        job {
          ... on Job {
            ...JobTeaserFragment
          }
        }
        score
      }
      errors
    }
  }
`;
export default getMatchingJobs;
